import React from "react";

import Badge from "components/Badge";

interface SaleStatusBadgeProps {
  label: string;
  color: string;
  forGrid?: boolean;
  editMode?: boolean;
}

export function SaleStatusBadge({
  label,
  color,
  forGrid = false,
  editMode = false,
}: SaleStatusBadgeProps): React.JSX.Element {
  // Even if it's read only, aggrid still bunts us into edit mode, which messes with where the whole cell sits.
  // This makes it a little less janky
  const style = editMode ? { margin: "0 10px" } : undefined;

  return (
    <Badge
      display={forGrid && !editMode ? "inline" : "inline-block"}
      margin="auto"
      height={forGrid ? 24 : undefined}
      color={color}
      style={style}
    >
      {label}
    </Badge>
  );
}
